import { AppRoutes } from 'common/routes'
import { Loader } from 'components/Loader'
import { Link } from 'react-router-dom'
import { IconSvg } from '@prism/icon'
import { setCustomClick } from 'utils/analyticsUtils'

interface Iprops {
  loading: boolean
  count: number
}

export const CurrentBidsCount = ({ loading, count }: Iprops) => {
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Link
          className="navigation-link"
          onClick={() => setCustomClick('Manage Bids', { usePageName: true })}
          to={AppRoutes.ManageBids}
        >
          <span className="right-action">
            <IconSvg glyph="dollar-o" color="primary" />
            &nbsp;Manage Bids&nbsp;<b>({count ?? 0})</b>
          </span>
        </Link>
      )}
    </>
  )
}
